module.exports = __webpack_public_path__ + "media/images/sp/stores/nara/main-visual-f5a2eb0fb9a1d462e41c98a8670fb80d.jpg";